export default __webpack_public_path__ + "fonts/Gotham-Light.4db73189a5f58cfe142231fad7d85afc.otf";